import { NgStyle } from '@angular/common';
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { Form } from '../../models';
import { FormInputsComponent } from './../form-inputs/form-inputs.component';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	standalone: true,
	imports: [
		ReactiveFormsModule,
		FormInputsComponent,
		NbButtonModule,
		NgStyle,
		TranslateModule
	]
})
export class FormComponent implements OnInit, OnDestroy {
	@Input() form: Form;
	@Output() save: EventEmitter<any> = new EventEmitter();
	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() reset: EventEmitter<any> = new EventEmitter();

	@ViewChild('htmlInputSubmit')
	private submitElement: ElementRef<HTMLInputElement>;

	ngOnInit(): void {
		this.form.submit = () => {
			this.submitElement.nativeElement.click();
		};
	}

	showFooter(): boolean {
		return !!this.form.footer;
	}

	showClearButton(): boolean {
		return this.form.footer && this.form.footer.clear !== undefined;
	}

	isSubmitDisabled(): boolean {
		return this.form.footer && this.form.footer.submit.disabled;
	}

	resetForm(): void {
		this.reset.emit();
		this.form.reset();
	}

	ngOnDestroy(): void {
		if (!this.form.skipDestroy) {
			this.form.onDestroy();
		}
	}
}
